<div *ngIf="showModal">
    <div class="modal-header">
        <h5 class="mb-0">{{ title | translate }}</h5>
    </div>
    <div class="modal-body">
        <form class="k-form k-form-md d-flex flex-column gap-2" [formGroup]="form">
            <div class="row">
                <div class="col-12">
                    <div class="mb-1 row">
                        <div class="col-12 col-md-2 col-xl-2">
                            <app-label controlName="language" class="col-form-label">{{ 'common.language' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-4 col-xl-4">
                            <input type="text" id="language" formControlName="language" class="form-control" />
                        </div>
                    </div>
                    <hr />
                    <h5>{{ 'email_resources.subject' | translate }}</h5>
                    <div class="mb-2 row">
                        <div class="col-12 col-md-2 col-xl-2">
                            <app-label controlName="subjectKey" class="col-form-label">{{ 'common.key' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-4 col-xl-4">
                            <input type="text" id="subjectKey" formControlName="subjectKey" class="form-control" />
                        </div>
                    </div>
                    <div class="mb-2 row">
                        <div class="col-12 col-md-2 col-xl-2">
                            <app-label controlName="subjectValue" class="col-form-label">{{ 'common.value' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-4 col-xl-4">
                            <input type="text" id="subjectValue" formControlName="subjectValue" class="form-control" />
                        </div>
                    </div>
                    <hr *ngIf="isSMSVisible" />
                    <h5 *ngIf="isSMSVisible">{{ 'email_resources.sms_body' | translate }}</h5>
                    <div class="mb-2 row" *ngIf="isSMSVisible">
                        <div class="col-12 col-md-2 col-xl-2">
                            <app-label controlName="smsBodyKey" class="col-form-label">{{ 'common.key' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-4 col-xl-4">
                            <input type="text" id="smsBodyKey" formControlName="smsBodyKey" class="form-control" />
                        </div>
                    </div>
                    <div class="mb-2 row" *ngIf="isSMSVisible">
                        <div class="col-12 col-md-2 col-xl-2">
                            <app-label controlName="smsBodyValue" class="col-form-label">{{ 'common.value' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-4 col-xl-4">
                            <textarea rows="10" id="smsBodyValue" formControlName="smsBodyValue" class="form-control"></textarea>
                            <app-field-error-message controlName="smsBodyValue"></app-field-error-message>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="col-12">
                    <h5>{{ 'email_resources.body' | translate }}</h5>
                    <div class="mb-2 row">
                        <div class="col-12 col-md-2 col-xl-2">
                            <app-label controlName="bodyKey" class="col-form-label">{{ 'common.key' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-4 col-xl-4">
                            <input type="text" id="bodyKey" formControlName="bodyKey" class="form-control" />
                        </div>
                    </div>
                    <div class="mb-2 row">
                        <div class="col-12 col-md-2 col-xl-2">
                            <app-label controlName="bodyValue" class="col-form-label">{{ 'common.value' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-10 col-xl-10 d-flex gap-4">
                            <div *ngIf="isAuthEmailType">
                                Authentication tokens
                                <br />
                                <div class="token-list" *ngFor="let authenticationToken of tokensList?.authenticationTokens" (click)="copyToClipboard(authenticationToken)">
                                    {{ authenticationToken }}
                                </div>
                            </div>
                            <div *ngIf="isAffiliateEmailType">
                                Affiliate tokens
                                <br />
                                <div class="token-list" *ngFor="let affiliateToken of tokensList?.affiliateTokens" (click)="copyToClipboard(affiliateToken)">
                                    {{ affiliateToken }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-12 col-xl-12">
                        <div class="d-flex flex-column flex-md-row gap-4 my-4 col-12 col-md-6" [formGroup]="testEmailForm">
                            <input type="text" class="form-control" [placeholder]="'common.email' | translate" id="toEmail" formControlName="toEmail" />
                            <button type="submit" [appClickWait]="sendEmailByType" class="btn btn-info" themeColor="info">
                                {{ 'common.send_email' | translate }}
                            </button>
                        </div>
                        <textarea formControlName="bodyValue" id="summernote"></textarea>
                        <app-field-error-message controlName="bodyValue"></app-field-error-message>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="submit" [appClickWait]="onSave" class="btn btn-primary" themeColor="primary">
            {{ 'common.save' | translate }}
        </button>
        <button class="btn btn-secondary" (click)="onClose()">{{ 'common.cancel' | translate }}</button>
    </div>
</div>
